<template>
  <div class="LoginStyle">
    <!-- <top-component style="height: 35px;"></top-component> -->
    <div class="content" style="flex: 1;">
      <div class="bgimages">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <h1 style="margin-bottom:22px ; text-align: center; font-size: 36px; color: #ff443b;">云田购线上选书、荐购平台</h1>
          <!-- <div class="loginmethod">
            <div class="loginmethodid" :class="{ 'selected': selectedMethod == '1' }" @click="selectMethod('1')">账号密码登录
            </div>
            <div class="loginmethodiphone" :class="{ 'selected': selectedMethod == '2' }" @click="selectMethod('2')">
              验证码登录</div>
          </div> -->
          <el-form-item label="机构" prop="orgGid">
            <el-select clearable filterable :filter-method="filterMethod" v-model="ruleForm.orgGid" placeholder="请输入关键字选择图书馆"
              :disabled="disablednew" @change="handleOrgSelection">
              <el-option v-for="item in options" :key="item.gid" :label="item.orgName" :value="item.gid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="登录方式">
            <div>
              <el-radio v-model="selectedMethod" :label="1">账号密码登录</el-radio>
              <el-radio v-if="isregist" v-model="selectedMethod" :label="2">验证码登录</el-radio>
            </div>
          </el-form-item>
          <el-form-item label="用户名" prop="passPort" v-if="selectedMethod == 1">
            <el-input v-model="ruleForm.passPort" :clearable="true" @keyup.native.enter="submitForm(ruleForm,1)"
              placeholder="请输入用户名" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="passWord" v-if="selectedMethod == 1">
            <el-input type="password" :clearable="true" @keyup.native.enter="submitForm(ruleForm,1)"
              v-model="ruleForm.passWord" autocomplete="off" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="passPort" v-if="selectedMethod == 2">
            <el-input v-model="ruleForm.passPort" :clearable="true" @keyup.native.enter="submitForm(ruleForm, 1)"
              placeholder="请输入手机号" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="passWord" v-if="selectedMethod == 2">
            <div style="display: flex;">
              <el-input :clearable="true" @keyup.native.enter="submitForm(ruleForm,1)" v-model="ruleForm.passWord"
                autocomplete="off" placeholder="请输入验证码"></el-input>
              <el-button style="margin-left: 10px;" :disabled="countdown > 0" @click="sendVerificationCode"
                :loading="sendingCode">{{ countdown > 0 ? countdown + 's后重新发送' : '获取验证码' }}</el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <div :style="{ display: 'flex', justifyContent: justifyContentStyle }">
            <el-button v-if="showThirdButton" type="danger" style="width: 100%;" @click="submitForm(ruleForm, 1)"
              :loading="loadings">{{ loading ? '登录中...' : '登录' }}</el-button>
            <el-button v-if="!showThirdButton" type="danger" style="width: 50%;" @click="submitForm(ruleForm, 0)"
              :loading="loading">{{ loading ? '登录中...' : '图采会登录' }}</el-button>
            <el-button v-if="!showThirdButton" type="danger" style="width: 50%;" @click="submitForm(ruleForm, 1)"
              :loading="loadings">{{ loading ? '登录中...' : '登录' }}</el-button>
            </div>
          </el-form-item>

          <!--  -->
          <div style="margin-right: 10px; color: #48a2ff; text-decoration: underline; cursor: pointer; text-align: right;" v-if="showswitchingmechanism" @click="switchingmechanism()">切换机构</div>
        </el-form>
      </div>
    </div>
    <bottom-component :is-login-page="true" class="BootmStyle" style="height: 100px;"></bottom-component>
  </div>
</template>

<script>
  import { encrypt } from '@/sealFilter/filter'
  import { actioncheck, orgactionsearch, actionphonecheck } from '@/api/authority'
  import { insertPoint } from '@/api/insertPoints'
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import { actionlistnum, getsendverificationcode, showindependently } from '@/api/pages'
  import Cookies from 'js-cookie'
  import { Base64 } from 'js-base64'
  import Qs from 'qs'
  export default {
    name: 'Login',
    data() {
      return {
        Requestparams: {},
        selectedMethod: 1, // 保存当前选中的登录方式
        countdown: 0, // 验证码倒计时
        sendingCode: false, // 是否正在发送验证码
        loading: false,
        loadings: false,
        showThirdButton: false, // 是否显示第三个按钮
        ruleForm: {
          passPort: '',//'test', sxwhcmgly
          passWord: '',//'123456', 123456
          orgGid: '',
          devType: 'WEB',
          istch: '1',

        },
        timer: null,
        disablednew: false,
        showswitchingmechanism: false,
        isregist: false,
        rules: {
          orgGid: [
            { required: true, message: '请选择机构！', trigger: 'change' }
          ],
          passPort: [], // 用户名或手机号的验证规则
          passWord: [], // 密码或验证码的验证规则
        },
        // iphone: [
        //   { required: true, message: '请输入手机号', trigger: 'blur' },
        //   {
        //     validator(rule, value, callback) {
        //       var nameRe = new RegExp(/^1[3456789]\d{9}$/);
        //       if (!nameRe.test(value)) {
        //         callback(new Error('请输入正确的手机号'));
        //       } else {
        //         callback();
        //       }
        //     }, trigger: 'blur'
        //   }
        // ],
        // code: [
        //   { required: true, message: '请输入验证码', trigger: 'blur' }
        // ]
        options: [],
        optionsSelect: [],
        value: '请选择图书馆'
      };
    },
    created() {
      // 获取图书馆的数据
      if (this.$route.params.baseid) {
        this.filterMethods(this.$route.params.baseid);
        this.disablednew = true
        this.showswitchingmechanism = true
      } else {
        this.disablednew = false
        // this.filterMethod('');

      }
    },
    mounted() {
      let vm = this
    //   vm.filterMethod('');
      const parameters = vm.getUrlParameters();
    //   console.log(parameters,Base64.decode(parameters[2]), 'parameters');
      if (parameters.length != 0) {
        let forms = {
          passPort: parameters[0],
          passWord: 'JGfzcJIFY5bbjwvIPhHqZdEjjoFSm/SHO9wYyuXLT7S13ue7QGEhyKxlKLUOpPrdj3+0iXjanZRsajgGySEfWg==',
          orgGid: parameters[1],
          devType: "WEB",
          istch: "1",
          source: 1,
        }
        let type = 1
        actioncheck(forms).then(res => {
          type == 0 ? vm.loading = false : vm.loadings = false;
          if (res.code == '200') {
            vm.deelLoginData(type, forms, res.data);
          }
        }).catch(err => {
          type == 0 ? vm.loading = false : vm.loadings = false;
        });
      }

    },
    computed: {
      justifyContentStyle() {
        return this.showThirdButton ? 'space-around' : 'center';
      }
    },
    watch: {
      // 监听登录方式的变化，根据变化设置对应的验证规则
      selectedMethod: {
        handler(val) {
          this.setValidationRules();
        },
        immediate: true
      }
    },
    components: {
      BottomComponent,
      TopComponent
    },
    methods: {
      getUrlParameters() {
        const url = window.location.href;
        console.log(url, 'url');
        const queryString = url.split('?')[1]; // 分割 URL，获取查询参数部分
        const parametersArray = [];
        if (queryString) {
          const params = queryString.split('&'); // 分割参数字符串
          params.forEach(param => {
            const keyValue = param.split('='); // 分割键值对
            if (keyValue.length === 2) {
              parametersArray.push(keyValue[1]); // 将值添加到数组中
            }
          });
        }
        return parametersArray;
      },
      // 根据登录方式设置对应的验证规则
      setValidationRules() {
        // 重置验证规则
        this.rules.passPort = [];
        this.rules.passWord = [];
        if (this.selectedMethod == 1) { // 账号密码登录
          this.rules.passPort = [
            { required: true, message: '用户名是必填项！', trigger: 'blur' },
            {
              validator(rule, value, callback) {
                var nameRe = new RegExp(/^[A-Za-z0-9]{4,50}$/);
                if (!nameRe.test(value.trim())) {
                  callback(new Error('用户名只允许输入字母和数字且长度为4-50'));
                } else {
                  callback();
                }
              }, trigger: 'blur'
            }
          ];
          this.rules.passWord = [
            { required: true, message: '密码输入位数不少于6位', trigger: 'blur' },
            { min: 6, message: '密码输入位数不少于6位', trigger: 'blur' }
          ];
        } else if (this.selectedMethod == 2) { // 验证码登录
          this.rules.passPort = [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
          ];
          this.rules.passWord = [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ];
        }
        // 清除验证状态
        this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate(['passPort', 'passWord']);
        });
      },

      async handleOrgSelection(value) {
        let data = { orgGid: value };
        this.selectedMethod = 1;
        let res = await showindependently(data)
        if (res.code == '200') {
          this.roleRule = res.data.data;
          this.isregist = res.data.data.isregist;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 5 * 1000
          });
        }
      },
      // 点击发送验证码按钮
      sendVerificationCode() {
        this.sendingCode = true;
        this.sendverificationcode(); // 发送验证码请求
        this.countdown = 60; // 重置倒计时
        this.timer = setInterval(() => {
          this.countdown--;
          if (this.countdown === 0) {
            clearInterval(this.timer);
            this.sendingCode = false;
          }
        }, 1000);
      },
      // 发送验证码请求
      async sendverificationcode() {
        let data = {
          passPort: this.ruleForm.passPort,
          orgGid: this.ruleForm.orgGid,
        }
        let res = await getsendverificationcode(data)
        if (res.code == '200') {
          console.log('成功！');
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 5 * 1000
          });
        }
      },
      async filterMethods(val) {
        let data = {
          orgCode: val,
          pageSize: 10,
          pageNum: 1,
          orgType: 1,
        }
        let res = await orgactionsearch(data)
        if (res.code == '200') {
          this.ruleForm.orgGid = res.data.list[0].gid
          this.options = res.data.list;
          //   this.handleOrgSelection(this.ruleForm.orgGid, res.data.list[0])
        }
      },
      // 模糊搜索
      async filterMethod(val) {
        let data = {
          orgType: 1,
          orgName: val,
          pageSize: 10,
          pageNum: 1,
        }
        if(val != ''){
            let res = await orgactionsearch(data)
            if (res.code == '200') {
                this.options = res.data.list;
            }
        }
      },
      switchingmechanism() {
        this.disablednew = false
        // this.filterMethod('');
      },
      // 提交
      submitForm(obj, type) {
        let vm = this;
        obj.passPort = obj.passPort.trim();
        obj.passWord = obj.passWord.trim();
        vm.$refs.ruleForm.validate(valid => {
          if (valid) {
            type == 0 ? vm.loading = true : vm.loadings = true;
            let forms = Object.assign({}, obj);
            forms.passWord = encrypt(vm.ruleForm.passWord);
            forms.source = type
            if (vm.selectedMethod == 1) {
              actioncheck(forms).then(res => {
               
                type == 0 ? vm.loading = false : vm.loadings = false;
                if (res.code == '200') {
                  vm.deelLoginData(type, forms, res.data);
                }
              }).catch(err => {
                type == 0 ? vm.loading = false : vm.loadings = false;
              });
            } else if (vm.selectedMethod == 2) {
              actionphonecheck(forms).then(res => {
                type == 0 ? vm.loading = false : vm.loadings = false;
                if (res.code == '200') {
                  vm.deelLoginData(type, forms, res.data);
                }
              }).catch(err => {
                type == 0 ? vm.loading = false : vm.loadings = false;
              });
            } else {
              type == 0 ? vm.loading = false : vm.loadings = false;
              vm.$message({
                message: res.msg,
                type: "error",
                duration: 5 * 1000
              });
              return;
            }
          } else {
            type == 0 ? vm.loading = false : vm.loadings = false;
            return false;
          }
        })
      },
      // 展示购物车数据
      async getShopCarData() {
        let data = {
          userId: Cookies.get('UserID')
        }
        let res = await actionlistnum(data)
        if (res.code == '200') {
          this.$store.state.DataStorage.GoodLengthData = res.data.total;
        }
      },
      deelLoginData(type, forms, data) {
        let vm = this;
        Cookies.set('erpGid', data.erpGid)
        Cookies.set('token', data.token)
        Cookies.set('name', data.userName)
        Cookies.set('orgName', data.orgName)
        Cookies.set('UserID', data.gid)
        Cookies.set('orgGid', data.orgGid)
        Cookies.set('passPort', data.passport)
        // Cookies.set('passWord', data.password)
        Cookies.set('adminState', data.adminState)
        if (data.adminState == 0 || data.adminState == 1) {
          Cookies.set('source', 0)
        } else {
          Cookies.set('source', 1)
        }
        Cookies.set('shoppingCartPermissions', data.shoppingCartPermissions)
        // 是否登录的一个标识，用来展示导航头的我的购物车/xxx图书馆/xxx登录
        vm.$store.state.DataStorage.LoginShowOrNot = false;
        localStorage.setItem('user', JSON.stringify(data));

        if (type == 0) {
          insertPoint(forms, 'login', 0); //添加登录埋点
          localStorage.setItem('doId', 0);//添加埋点doId
        } else {
          insertPoint(forms, 'login', 1); //添加登录埋点
          localStorage.setItem('doId', 1);//添加埋点doId
        }
        if (localStorage.getItem('pageUrl')) {
          location.assign(localStorage.getItem('pageUrl'));
        } else {
          if (type == 0) {
            Cookies.remove('logintype')
            Cookies.set('logintype',0)
            vm.$router.push({ name: 'HomePage', params: { baseid: vm.$route.params.baseid } });
          } else {
            Cookies.remove('logintype')
            Cookies.set('logintype',1)
            vm.$router.push({ name: 'Xindex', params: { baseid: vm.$route.params.baseid } });
          }
        }
        // localStorage.setItem('roleInfo', JSON.stringify(vm.roleRule));
        clearInterval(vm.timer);
        vm.sendingCode = false;
        vm.getShopCarData();
      }
    }
  }
</script>

<style scoped lang="scss">
  .LoginStyle {
    width: 100%;
    height: 100vh;
    /* 让登录容器占满整个视口高度 */
    display: flex;
    flex-direction: column;
  }

  .demo-ruleForm {
    width: 500px;
    margin-left: calc(50% - 300px);
    border: 1px solid #ff6961;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    padding: 30px 70px 30px 30px;
    border-radius: 6px;
    /* margin-top: 150px; */
  }

  .BootmStyle {
    position: fixed;
    bottom: 0px;
  }

  .el-select {
    width: 400px;
  }

  .SearchInput {
    display: inline-block;
    width: 400px;
  }

  .SearchSelect {
    display: inline-block;
    width: 215px;
  }

  .bgimages {
    background-image: url('../../assets/images/loginbg.png');
    /* 替换 '/path/to/background.jpg' 为你的背景图路径 */
    background-size: cover;
    /* 保持背景图覆盖整个容器 */
    background-position: center;
    /* 将背景图居中显示 */
    width: 100%;
    /* 让背景图占满整个容器的宽度 */
    height: 100%;
    /* 让背景图占满整个容器的高度 */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .loginmethod {
    display: flex;
    justify-content: space-evenly;
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 30px
  }

  .loginmethodid {
    cursor: pointer;
    color: #606266;
  }

  .loginmethodiphone {
    cursor: pointer;
    color: #606266;
  }

  .loginmethodid.selected,
  .loginmethodiphone.selected {
    color: #4e97ff;
    /* 选中时的字体颜色 */
  }

  .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
</style>


// WEBPACK FOOTER //
// src/views/Login/Loginclosebeta.vue